import { render, staticRenderFns } from "./TypeOne.vue?vue&type=template&id=2e0b874e&scoped=true"
import script from "./TypeOne.vue?vue&type=script&lang=js"
export * from "./TypeOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0b874e",
  null
  
)

export default component.exports